import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export function useMutationGetInvoiceAsMember({ api }: { api: ApiType }) {
  return useMutation({
    mutationFn: async ({ invoiceNumber }: { invoiceNumber: string }) => {
      return (
        await api.profileApi.getInvoiceByInvoiceNumber(invoiceNumber)
      ).data;
    },
  });
}
